
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import theme from '../common/theme';

const classNames = mergeStyleSets({
    root: {
        paddingBottom: 8
    }
});

const ObjectInfoTitle = (props) => {
    return (
        <Stack horizontal verticalAlign="baseline" tokens={{childrenGap: 8}} className={classNames.root}>
            <Stack.Item>
                <Text large bold color={theme.fabricTheme.palette.neutralTertiary}>{props.title}</Text>
            </Stack.Item>
            <Stack.Item>
                {props.content}
            </Stack.Item>
        </Stack>
    )
};

export default ObjectInfoTitle;
